<template>
  <div class="shenyunjie-chart-pie" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import merge from "deepmerge";

export default {
  name: "YunJieChartPie",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: Array,
      default: function () {
        return [];
      }
    },
    pattern: {
      type: String,
      default: "circle"
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      defaultOption: {
        title: {
          left: "center"
        },
        tooltip: {
          trigger: "item"
        }
      },
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizePie);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizePie() {
      let self = this;
      if (self.chart) {
        self.chart.resize();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        let theme = self.theme || (this.$YunJie || {}).theme || "standard";
        if (!self.chart) {
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark");
          } else {
            self.chart = echarts.init(document.getElementById(self.id));
          }
        }
        // 配置汇总
        let height = document.getElementById(self.id).offsetHeight;
        let width = document.getElementById(self.id).offsetWidth;
        let legend = {
          top: "26px",
          left: "center"
        };
        if (width > height + 160) {
          legend = {
            orient: "vertical",
            top: "middle",
            left: "left"
          };
        }
        let radius = "50%";
        if (self.pattern != "simple") {
          radius = ["40%", "70%"];
        }
        let parameter = {
          title: {
            text: self.title
          },
          legend: legend,
          series: [{
            type: "pie",
            radius: radius,
            avoidLabelOverlap: self.pattern != "simple",
            itemStyle: self.pattern == "circle" ? {
              borderRadius: 10,
              borderColor: theme == "darkness" ? "#100C2A" : "#ffffff",
              borderWidth: 2
            } : {},
            label: self.pattern != "simple" ? {
              show: false,
              position: "center"
            } : {},
            emphasis: self.pattern != "simple" ? {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold"
              }
            } : {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            },
            labelLine: self.pattern != "simple" ? {
              show: false
            } : {},
            data: self.value
          }],
          tooltip: {
            show: self.tooltip
          }
        };
        let opt = merge(self.defaultOption, parameter);
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizePie);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    value: {
      deep: true,
      handler(xData) {
        this.init();
      }
    },
    pattern() {
      this.init();
    },
    tooltip() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-pie {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/pie.vue